import React from "react";
import SidebarItem from "./SidebarItem";

const SidebarList = ({ songOptions, playingTitle }) => {
  const options = ["Bollywood trending", "Bollywood 90s", "Hollywood"];
  return (
    <div className=" mt-3">
      {options.map((op) => {
        return (
          <SidebarItem
            name={op}
            songOptions={songOptions}
            playingTitle={playingTitle}
          />
        );
      })}
    </div>
  );
};

export default SidebarList;
